import { useRef, useEffect, useCallback } from 'react';

function useDebounce(func, delay) {
  const timeoutRef = useRef(null);
  const memoizedFunc = useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      func(...args);
    }, delay);
  }, [func, delay]);

  useEffect(() => {
    return () => { // Cleanup on unmount
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return memoizedFunc;
}

export default useDebounce;
